import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingSpinner from "./LoadingSpinner";
import type { ReactNode } from "react";

interface RootRouteProps {
  children: ReactNode;
}

/**
 * Guards pages accessible only to the root/superuser.
 * - Loading → spinner
 * - Unauthenticated → /login
 * - Not root → /admin (they may still be admin)
 */
export default function RootRoute({ children }: RootRouteProps) {
  const { currentUser, isRoot, loading } = useAuth();

  if (loading) {
    return (
      <LoadingSpinner size="lg" fullScreen />
    );
  }

  if (!currentUser) return <Navigate to="/login" replace />;
  if (!isRoot) return <Navigate to="/admin" replace />;

  return <>{children}</>;
}
